











































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { HTTP } from '@/plugins/axios'
import {DeleteEventoInfoDTO, EventoDTO} from '@/interfaces/Evento.interface'
import { TextMSGDTO } from '@/interfaces/DialogNewRolUsuario.interface'
import { DialogConfirmActionDTO } from '@/interfaces/DialogConfirmAction.interface'
import DialogNewEvento from '@/components/dialogNewEvento.vue'
import moment from 'moment'
moment.locale('es-MX')

@Component({
  components: {
    DialogNewEvento
  }
})
export default class ViewEventoInfo extends Vue {
  private name: string = 'ViewEventoInfo'
  private menuFecha: boolean = false
  private infoEvento: object = {}
  private actionEvento: string = 'new'
  private updateEventoTable: boolean = false
  private action: string = 'new'
  private fechaEvento: string = ''
  private fechasEvento: string[] = []
  private evento: EventoDTO[] = []
  private textMSG: TextMSGDTO = {
    success: {
      text: 'Nuevo Evento:',
      color: 'success'
    },
    delete: {
      text: 'Nuevo Evento:',
      color: 'success'
    },
    update: {
      text: 'Modificado Evento:',
      color: 'info'
    },
    fail: {
      text: 'Error al guardar:',
      color: 'error'
    },
  }
  /* DELETE EVENTO CONFIRM */
  private deleteEventoInfo: DeleteEventoInfoDTO = {
    id: 0,
    name: ''
  }
  private ConfirmDeleteEventoInfo: DialogConfirmActionDTO = {
    title: 'Eliminar Evento',
    msg: 'Esta seguro que desea eliminar el Evento:',
    color: 'error',
    show: true,
    status: undefined,
    action: 'deleteEvento'
  }
  private get ConfirmDeleteAction (): DialogConfirmActionDTO {
    console.log('ViewEventoInfo :: ConfirmDeleteAction :: ', this.$store.state.appState.DialogConfirmAction)
    return this.$store.state.appState.DialogConfirmAction
  }
  private header: any[] = [
    {
      text: 'Nombre',
      align: 'left',
      sortable: true,
      value: 'name'
    },
    { text: 'Fecha Inicio', value: 'dateBeg' },
    { text: 'Fecha Fin', value: 'dateEnd' },
    { text: 'Acciones', value: 'acciones' }
  ]
  @Watch('ConfirmDeleteAction')
  private watchConfirmDeleteAction (v: DialogConfirmActionDTO) {
    console.log('watchConfirmDeleteAction :: ', v)
    if ((v.action === 'deleteEvento') && (v.status)) {
      console.log('watchConfirmDeleteAction :: DeleteEvento :: ', this.deleteEventoInfo)
      this.DeleteEvento (this.deleteEventoInfo.id, this.deleteEventoInfo.name)
    }
  }
  @Watch('fechaEvento')
  private watchFechaEvento (v: string) {
    console.log('watchFechaEvento :: ', v)
    this.fechasEvento.push(moment(v).format('MM/DD/YYYY'))
  }

  @Watch('updateEventoTable')
  private watchUpdateEventoTable (v: boolean) {
    console.log('watchUpdateEventoTable :: ', v)
    this.FindEventos()
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    this.FindEventos()
  }

  private DeleteDate (d: string) {
    console.log('DeleteDate :: ', d)
    const f = this.fechasEvento.indexOf(d)
    console.log('DeleteDate :: f :: ', f)
    this.fechasEvento.splice(f, 1)
  }

  private editarEvento (item: EventoDTO) {
    item.dateBeg = moment(item.dateBeg).format('YYYY-MM-DD')
    item.dateEnd = moment(item.dateEnd).format('YYYY-MM-DD')
    this.infoEvento = Object.assign({}, item)
    this.actionEvento = 'edit'
  }
  private FindEventos () {
    console.log('FindEventos :: ')
    HTTP.get('evento/')
      .then((response) => {
        console.log('FindEventos :: response :: ', response.data)
        this.evento = response.data
      })
      .catch((e) => {
        console.log('FindEventos :: catch :: ', e.response.data)
      })
  }

  private activarEvento (item: EventoDTO) {
    HTTP.get('evento/' + item.id + '/activate')
      .then((response) => {
        console.log('UpdateEvento :: response :: ', response.data)
        this.FindEventos()
        if (response.data.success) {
          this.$store.commit('setSnackbarMsg',  {
            text: this.textMSG.update.text + ' ' + item.name,
            color: this.textMSG.update.color,
            show: true,
            timeout: 2000
          })
        }
      })
      .catch((e) => {
        console.log('UpdateEvento :: catch :: ', e.response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.fail.text + ' ' + item.name,
          color: this.textMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }

  private ConfirmDeleteEvento (id: number, name: string) {
    console.log('ConfirmDeleteEvento :: id :: ', id)
    console.log('ConfirmDeleteEvento :: name :: ', name)

    this.deleteEventoInfo.id = id
    this.deleteEventoInfo.name = name

    this.$store.commit('setDialogConfirmAction',  {
      title: this.ConfirmDeleteEventoInfo.title,
      msg: this.ConfirmDeleteEventoInfo.msg + ' ' + name,
      color: this.ConfirmDeleteEventoInfo.color,
      show: this.ConfirmDeleteEventoInfo.show,
      status: this.ConfirmDeleteEventoInfo.status,
      action: this.ConfirmDeleteEventoInfo.action
    })
  }
  private DeleteEvento (id: number, name: string) {
    HTTP.delete('evento/' + id)
      .then((response) => {
        console.log('DeleteEvento :: response :: ', response.data)
        if (response.data.success) {
          this.FindEventos()
          this.$store.commit('setSnackbarMsg',  {
            text: this.textMSG.delete.text + ' ' + name,
            color: this.textMSG.delete.color,
            show: true,
            timeout: 2000
          })
        } else {
          this.$store.commit('setSnackbarMsg',  {
            text: response.data.info,
            color: this.textMSG.fail.color,
            show: true,
            timeout: 2000
          })
        }
      })
      .catch((e) => {
        console.log('DeleteEvento :: catch :: ', e.response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.fail.text + ' ' + name,
          color: this.textMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }
}
